import React, { CSSProperties, PropsWithChildren } from 'react';
import styles from './ASBox.module.scss';

type ASBoxOwnProps = {
  className?: string;
  noMinWidth?: boolean;
  maxWidth?: boolean;
  maxHeight?: boolean;
  darkBg?: boolean;
  style?: CSSProperties;
  ref?: React.Ref<HTMLDivElement>;
} & React.HTMLAttributes<HTMLDivElement>;

type ASBoxProps = PropsWithChildren<ASBoxOwnProps>;
const ASBox: React.FC<ASBoxProps> = ({
  className = '',
  noMinWidth = false,
  maxHeight = false,
  maxWidth = false,
  darkBg = false,
  style,
  children,
  ref,
  ...rest
}) => {
  const darkBgCls = darkBg ? styles.ASBoxWithDarkBg : '';
  const minWidthCls = noMinWidth ? '' : styles.ASBoxWithMinWidth;
  const maxWidthCls = maxWidth ? styles.ASBoxMaxWidth : '';
  const maxHeightCls = maxHeight ? styles.ASBoxMaxHeight : '';
  const baseCls = `${styles.ASBox} ${maxWidthCls} ${minWidthCls} ${maxHeightCls} ${darkBgCls} ${className}`;
  return (
    <div {...rest} ref={ref} className={baseCls} style={style}>
      {children}
    </div>
  );
};

export default ASBox;
